import { useQuery, UseQueryOptions } from '@tanstack/react-query';

const URL = '/api/list-referrals';

export type ListReferralsResponse = {
  referrals?: string[];
  error?: string;
};

const LIST_REFERRALS_KEY = ['referrals', 'list'] as const;

const listReferrals = async (): Promise<string[]> => {
  const response = await fetch(URL);

  if (!response.ok) {
    throw new Error('Failed to load referral sources');
  }

  const data: ListReferralsResponse = await response.json();

  return data.referrals ?? [];
};

export const useListReferralsQuery = (
  options?: Partial<UseQueryOptions<string[], Error>>
) =>
  useQuery<string[], Error>({
    queryKey: LIST_REFERRALS_KEY,
    queryFn: listReferrals,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    ...options,
  });
